import { Button, Grid, Stack } from "@mui/material";
import useCheckoutStore from "../../../../../stores/public/useCheckoutStore";
import { useForm } from "react-hook-form";
import create from "../../../../../api/public/storePages/locations/create";
import update from "../../../../../api/public/storePages/locations/update";
import updateReservation from "../../../../../api/public/storePages/reservations/update";
import WushTextField from "../../../../form/WushTextField";
import WushStateSelect from "../../../../form/WushStateSelect";

export default function DeliveryInformationForm({ nextStep, previousStep }) {
  const { location, setLocation, storePage, reservation } = useCheckoutStore();
  const { register, handleSubmit, formState } = useForm({
    defaultValues: location,
    reValidateMode: 'onSubmit'
  });

  const onSubmit = (values) => {
    if(location?.id) {
      update(storePage.id, location.id, values, (response) => {
        updateReservation(storePage.id, reservation.id, {
          location_id: response.id
        }, (response) => {
          console.log(response);
          nextStep();
        });
        setLocation(response);
      });
    } else {
      create(storePage.id, values, (response) => {
        updateReservation(storePage.id, reservation.id, {
          location_id: response.id
        }, (response) => {
          console.log(response);
          nextStep();
        });
        setLocation(response);
      });
    }
  };

  console.log(location);

  return (
    <Stack>
      <Stack>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack gap={1} mb={1}>
            <Grid container spacing={2}>
              <Grid item sm={6}>
                <Stack>
                  <WushTextField formRegistration={register('address_1')} formState={formState} label="Address 1" defaultValue={location?.address_1} />
                </Stack>
              </Grid>
              <Grid item sm={6}>
                <Stack>
                  <WushTextField formRegistration={register('address_2')} formState={formState} label="Address 2" defaultValue={location?.address_2} />
                </Stack>
              </Grid>
              <Grid item sm={6}>
                <Stack>
                  <WushTextField formRegistration={register('city')} formState={formState} label="City" defaultValue={location?.city} />
                </Stack>
              </Grid>
              <Grid item sm={6}>
                <Stack>
                  <WushStateSelect formRegistration={register('state')} formState={formState} label="State" defaultValue={location?.state} />
                </Stack>
              </Grid>
              <Grid item sm={6}>
                <Stack>
                  <WushTextField formRegistration={register('zip')} formState={formState} label="Zip" defaultValue={location?.zip} />
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </form>
      </Stack>
      <Stack direction="row" width="100%" justifyContent="center">
        <Button onClick={previousStep}>Back</Button>
        <Button variant="contained" onClick={handleSubmit(onSubmit)}>Next</Button>
      </Stack>
    </Stack>
  );
}